/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown>, count: NonNullable<unknown>, noun: NonNullable<unknown> }} Endpoint_Cost_CeilingInputs */

const en_endpoint_cost_ceiling = /** @type {(inputs: Endpoint_Cost_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`One request costs at most ${i?.cost} (${i?.count} ${i?.noun}).`)
};

const zh_hans1_endpoint_cost_ceiling = /** @type {(inputs: Endpoint_Cost_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`单次请求最多 ${i?.cost}（${i?.count} ${i?.noun}）。`)
};

const pt_br2_endpoint_cost_ceiling = /** @type {(inputs: Endpoint_Cost_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uma requisição custa no máximo ${i?.cost} (${i?.count} ${i?.noun}).`)
};

const es_endpoint_cost_ceiling = /** @type {(inputs: Endpoint_Cost_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una solicitud cuesta como máximo ${i?.cost} (${i?.count} ${i?.noun}).`)
};

const fr_endpoint_cost_ceiling = /** @type {(inputs: Endpoint_Cost_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Une requête coûte au plus ${i?.cost} (${i?.count} ${i?.noun}).`)
};

const de_endpoint_cost_ceiling = /** @type {(inputs: Endpoint_Cost_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eine Anfrage kostet höchstens ${i?.cost} (${i?.count} ${i?.noun}).`)
};

const ru_endpoint_cost_ceiling = /** @type {(inputs: Endpoint_Cost_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Один запрос стоит не больше ${i?.cost} (${i?.count} ${i?.noun}).`)
};

const it_endpoint_cost_ceiling = /** @type {(inputs: Endpoint_Cost_CeilingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una richiesta costa al massimo ${i?.cost} (${i?.count} ${i?.noun}).`)
};

/**
* | output |
* | --- |
* | "One request costs at most {cost} ({count} {noun})." |
*
* @param {Endpoint_Cost_CeilingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cost_ceiling = /** @type {((inputs: Endpoint_Cost_CeilingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Cost_CeilingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_cost_ceiling(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_cost_ceiling(inputs)
	if (locale === "es") return es_endpoint_cost_ceiling(inputs)
	if (locale === "fr") return fr_endpoint_cost_ceiling(inputs)
	if (locale === "de") return de_endpoint_cost_ceiling(inputs)
	if (locale === "ru") return ru_endpoint_cost_ceiling(inputs)
	if (locale === "it") return it_endpoint_cost_ceiling(inputs)
	return en_endpoint_cost_ceiling(inputs)
});